// Run on page load
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    runAnimation('side-by-side', 'fade');
    runAnimation('side-card__image-wrapper', 'fade');
    runAnimation('billboard', 'fade');
    runAnimation('visit-us-stylists__block-image-container', 'fade');
  }, 500);
});

// Run on scroll with throttle
window.addEventListener('scroll', function () {
  runAnimation('side-by-side', 'fade');
  runAnimation('side-card__image-wrapper', 'fade');
  runAnimation('billboard', 'fade');
  runAnimation('visit-us-stylists__block-image-container', 'fade');
});

function runAnimation(selector, addedClass) {
  var elements = document.querySelectorAll('.' + selector);
  // Don't run the rest of the code if every title is already visible
  if (document.querySelectorAll('.' + selector + ':not(.' + addedClass + ')').length === 0) return;

  // Run this code for every title in titles

  var _loop = function _loop(el) {
    if (el.getBoundingClientRect().top <= window.innerHeight * 0.9 && el.getBoundingClientRect().top > 0 && !el.classList.contains('' + addedClass)) {
      el.classList.add(addedClass);
      el.addEventListener('animationend', function () {
        setTimeout(function () {
          el.classList.add('animationComplete');
        }, 500);
      }, false);
    }
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      _loop(el);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}